import React from 'react';

const sectionHeadingStyle = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 700,
  letterSpacing: '0.05em',
};

export default function PageHero({
  eyebrow,
  title,
  subtitle,
  note,
  callout,
  className = 'pb-16 md:pb-20',
  maxWidth = 'max-w-3xl',
}) {
  return (
    <section className={`px-4 md:px-8 ${className}`}>
      <div className={`${maxWidth} mx-auto text-center`}>
        {eyebrow && (
          <p
            className="text-xs uppercase tracking-wider mb-3 font-semibold"
            style={{ fontFamily: "'Poppins', sans-serif", color: '#ff7a59' }}
          >
            {eyebrow}
          </p>
        )}
        <h1
          className="text-3xl md:text-5xl font-bold mb-4 text-gray-700"
          style={sectionHeadingStyle}
        >
          {title}
        </h1>
        {subtitle && (
          <p
            className="text-base md:text-lg max-w-xl mx-auto mb-6"
            style={{ fontFamily: "'Poppins', sans-serif", color: '#292929' }}
          >
            {subtitle}
          </p>
        )}
        {callout && (
          <div
            className="inline-flex flex-col sm:flex-row items-center gap-2 sm:gap-3 rounded-2xl px-5 py-4 mb-6 text-left shadow-md border"
            style={{
              backgroundColor: 'rgba(255, 252, 240, 0.9)',
              borderColor: 'rgba(255, 122, 89, 0.45)',
            }}
          >
            {callout.badge && (
              <span
                className="shrink-0 text-xs font-bold uppercase tracking-wide px-3 py-1.5 rounded-full text-white"
                style={{ backgroundColor: '#ff7a59', fontFamily: "'Poppins', sans-serif" }}
              >
                {callout.badge}
              </span>
            )}
            <p
              className="text-sm md:text-base font-medium text-center sm:text-left"
              style={{ fontFamily: "'Poppins', sans-serif", color: '#292929' }}
            >
              {callout.text}
            </p>
          </div>
        )}
        {note && (
          <p
            className="text-sm text-gray-600"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            {note}
          </p>
        )}
      </div>
    </section>
  );
}
